import { Component, OnInit, ViewChild } from '@angular/core';
import { MatAutocompleteTrigger, MatAutocompleteSelectedEvent } from '@angular/material';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { startWith, map } from 'rxjs/operators';
import { MenuService } from '../../../services/menu/menu.service';
import { SeleccionProducto } from '../../../models/menu/seleccion-producto.class';
import { RedireccionService } from '../../../services/redireccion/redireccion.service';
import { DialogService } from '../../../services/dialog/dialog.service';
import { MensajeSnackBarService } from '../../../services/mensaje-snack-bar/mensaje-snack-bar.service';
import { UtilService } from '../../../services/util/util.service';
import { MasterMenuComponent } from '../master-menu/master-menu.component';


@Component({
  selector: 'app-busqueda-menu',
  templateUrl: './busqueda-menu.component.html',
  styleUrls: ['./busqueda-menu.component.css']
})
export class BusquedaMenuComponent extends MasterMenuComponent implements OnInit {


  @ViewChild(MatAutocompleteTrigger) trigger: MatAutocompleteTrigger;

  subscription: any;

  busqueda: String;


  control: FormControl = new FormControl();

  options: SeleccionProducto[] = [];

  filteredOptions: Observable<SeleccionProducto[]>;

  constructor(public menuService: MenuService, public redireccionService: RedireccionService,
    public dialogService: DialogService, public mensajeSnackBarService: MensajeSnackBarService,
    public utilService: UtilService) {
    super(redireccionService, dialogService, mensajeSnackBarService, utilService);
  }

  ngOnInit() {
    this.iniciarListaBusqueda();
    this.iniciarFiltroBusqueda();
  }



  iniciarListaBusqueda() {
    this.menuService.getListBusquedaMenu().subscribe((optionsBusqueda: SeleccionProducto[]) => {
      this.options = optionsBusqueda;
    });
  }

  iniciarFiltroBusqueda() {
    this.filteredOptions = this.control.valueChanges
      .pipe(
        startWith<string | SeleccionProducto>(),
        map(value => typeof value === 'string' ? value : value !== null ? value.nombreBusqueda : ''),
        map(nombreBusqueda => nombreBusqueda ? this.filter(nombreBusqueda) : this.options.slice())
      );
  }

  // tslint:disable-next-line:use-life-cycle-interface
  ngAfterViewInit() {
    this.subscription = this.trigger.panelClosingActions
      .subscribe(e => {
        this.trigger.closePanel();
      });
  }

  filter(nombreBusqueda: String): SeleccionProducto[] {
    nombreBusqueda.toLocaleLowerCase();
    const productos: SeleccionProducto[] = this.options.filter(option =>
      option.nombreBusqueda.toLowerCase().includes(nombreBusqueda.toLowerCase()));
    if (productos !== null) {
      productos.sort();
    }
    return productos;
  }

  displayFn(opcion?: SeleccionProducto): String | undefined {
    return opcion ? opcion.nombreBusqueda : undefined;
  }

  async seleccionOpcion(event: MatAutocompleteSelectedEvent) {
    const opcionMenu: SeleccionProducto = event.option.value;
    this.ejecutarOpcionSeleccionada(opcionMenu.menuItem);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/menu/busqueda-menu/busqueda-menu.component.ts